export default __webpack_public_path__ + "a5682600d86da3cf41ebc3d60d98af8f.png";